import { ISettingsFont } from '@wix/podcasts-common/dist/settings';

const lineClampStaticStyle = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical' as 'vertical',
  overflow: 'hidden',
};

const getLineClampStyles = (
  font: ISettingsFont = {},
  lineHeight: number,
  linesCount: number,
) => ({
  ...lineClampStaticStyle,
  WebkitLineClamp: linesCount,
  maxHeight: font.size * lineHeight * linesCount,
});

export default getLineClampStyles;
